<h3 mat-dialog-title>DP Capability</h3>

<mat-dialog-content>
    <form name="myForm" class="example-form">
        <mat-form-field class="example-full-width">
            <mat-label>DP capability plot</mat-label>
            <input matInput type="text" name="plot_name" [(ngModel)]="trailDocumentCapability.capability_plot_name">
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Remark to the plot</mat-label>
            <textarea matInput type="text" name="plot_remark" [(ngModel)]="trailDocumentCapability.capability_plot_remark"></textarea>
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>DP verifying footprint</mat-label>
            <input matInput type="text" name="footprint_name" [(ngModel)]="trailDocumentCapability.verifying_footprint_name">
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Remark to the footprint</mat-label>
            <textarea matInput type="text" name="footprint_remark" [(ngModel)]="trailDocumentCapability.verifying_footprint_remark"></textarea>
        </mat-form-field>

    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-icon-button matTooltip="delete" (click)="onDeleteClick()">
        <mat-icon>delete_outline</mat-icon>
    </button>

    <span class="example-spacer"></span>

    <button mat-button (click)="onCancelClick()">Cancel</button>

    <button mat-button extended (click)="onUpdateClick()" [mat-dialog-close]="trailDocumentCapability" cdkFocusInitial>
        Update
    </button>
</mat-dialog-actions>
